import script from "./ChipButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipButton.vue?vue&type=script&setup=true&lang=js"

import "./ChipButton.vue?vue&type=style&index=0&id=77804131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77804131"]])

export default __exports__